var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_686:26234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15C3 8.37211 8.37211 3 15 3C21.6279 3 27 8.37211 27 15C27 21.6279 21.6279 27 15 27C8.37211 27 3 21.6279 3 15ZM22.5436 16.9418C22.5436 16.7599 22.5287 16.5839 22.5019 16.4079C23.1074 16.0708 23.4802 15.4295 23.4773 14.7465C23.4743 13.6846 22.6152 12.8255 21.5563 12.8255C21.0761 12.8225 20.6107 13.0045 20.2558 13.3326C18.9881 12.5063 17.2908 11.9754 15.4116 11.9008L16.4497 8.73602L19.173 9.37733C19.176 10.2483 19.8829 10.9553 20.7539 10.9553C21.6279 10.9553 22.3348 10.2483 22.3348 9.37435C22.3348 8.50037 21.6279 7.79344 20.7539 7.79344C20.1186 7.79344 19.5459 8.17226 19.2983 8.75391L16.3125 8.04996L16.3065 8.04698L16.0261 7.98136L14.7465 11.8889C12.7957 11.9247 11.0298 12.4556 9.71439 13.2998C9.3654 12.9896 8.91499 12.8166 8.44072 12.8166C7.37882 12.8195 6.51976 13.6786 6.51976 14.7375C6.51976 15.4027 6.86577 16.0231 7.43251 16.3721C7.3997 16.557 7.38479 16.7479 7.38479 16.9418C7.38479 19.7308 10.7852 21.9978 14.9642 21.9978C19.1432 21.9978 22.5436 19.7308 22.5436 16.9418ZM14.9993 19.5608C16.0911 19.5608 16.8398 19.343 17.2842 18.8986C17.4065 18.7763 17.6093 18.7763 17.7316 18.8986C17.8539 19.0209 17.8539 19.2237 17.7316 19.346C17.1619 19.9158 16.2671 20.1932 14.9993 20.1932C13.7316 20.1932 12.8368 19.9158 12.2671 19.346C12.1418 19.2237 12.1448 19.0209 12.2671 18.8986C12.3894 18.7733 12.5922 18.7763 12.7145 18.8986C13.1589 19.343 13.9076 19.5608 14.9993 19.5608ZM17.5687 14.8331C16.9244 14.8331 16.3815 15.373 16.3815 16.0203C16.3815 16.6646 16.9244 17.1895 17.5687 17.1895C18.213 17.1895 18.7379 16.6676 18.7379 16.0203C18.7379 15.376 18.213 14.8331 17.5687 14.8331ZM12.45 14.8331C13.0973 14.8331 13.6193 15.376 13.6193 16.0203C13.6193 16.6646 13.0943 17.1895 12.45 17.1895C11.8027 17.1895 11.2628 16.6646 11.2628 16.0203C11.2628 15.376 11.8027 14.8331 12.45 14.8331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_686:26234",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_686:26234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_686:26234",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/Reddit.819bfa6c22d3e37a9c5b1705ad823d83.svg";
export { ForwardRef as ReactComponent };